var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';
import ApplicationOrderService from '../../../api/ApplicationOrderService';
import ClientService from '../../../api/ClientService';
import PurchaseService from '../../../api/PurchaseService';
import CommonService from '../../../api/CommonService';
import BasicArcheivesService from '../../../api/BasicArcheivesService';
import HeaderItem from '../../../components/HeaderItem';
function setTreeData(treeData, id, name) {
    treeData.forEach(function (item) {
        item.id = item[id];
        item.name = item[name];
        if (item.children && item.children.length) {
            setTreeData(item.children, id, name);
        }
    });
}
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.typeList = [];
        _this.customerList = [];
        _this.depotList = [];
        _this.supplierList = [];
        _this.cascader_props = {
            value: 'id',
            label: 'name',
            emitPath: false,
        };
        _this.timePickerOptions = {
            disabledDate: function (time) {
                return time.getTime() > Date.now();
            },
        };
        return _this;
    }
    default_1.prototype.created = function () {
        this.service = ApplicationOrderService.getInstance();
        this.clientService = ClientService.getInstance();
        this.purchaseService = PurchaseService.getInstance();
        this.commonService = CommonService.getInstance();
        this.basicArcheivesService = BasicArcheivesService.getInstance();
        if (this.handleStatus === 1)
            this.getTypeList();
        this.getCustomerList();
        this.getSupplier();
        if (this.openedCodeData.isOpenMultOrg) {
            this.getOrganDepotList();
        }
        else {
            this.getDepotList();
        }
    };
    default_1.prototype.getSupplier = function () {
        var _this = this;
        this.basicArcheivesService.getSupplierupperCategoryList().then(function (res) {
            var supplierData = Array.isArray(res.data.data) ? res.data.data : [];
            supplierData.forEach(function (item, index) {
                item.supplier_upper_id = new Date().getTime() + index;
                item.supplier_upper_name = item.category_name;
            });
            setTreeData(supplierData, 'supplier_upper_id', 'supplier_upper_name');
            _this.supplierList = supplierData;
        });
    };
    default_1.prototype.getCustomerList = function () {
        var _this = this;
        this.clientService
            .getClientsByGroup({
            business_status: 1,
        })
            .then(function (res) {
            var listData = Array.isArray(res.data.data) ? res.data.data : [];
            listData.forEach(function (item, index) {
                item.supplier_to_business_id = new Date().getTime() + index;
                item.business_name = item.group_name;
            });
            setTreeData(listData, 'supplier_to_business_id', 'business_name');
            _this.customerList = listData;
        });
    };
    default_1.prototype.getTypeList = function () {
        var _this = this;
        this.service.getTypeList().then(function (res) {
            var data = Array.isArray(res.data.data) ? res.data.data : [];
            _this.typeList = data;
        });
    };
    default_1.prototype.getOrganDepotList = function () {
        var _this = this;
        this.commonService.getOrganDepot().then(function (res) {
            var listData = Array.isArray(res.data.data) ? res.data.data : [];
            listData.forEach(function (item, index) {
                item.depot_id = new Date().getTime() + index;
                item.depot_name = item.organ_name;
            });
            setTreeData(listData, 'depot_id', 'depot_name');
            _this.depotList = listData;
        });
    };
    default_1.prototype.getDepotList = function () {
        var _this = this;
        this.purchaseService.getSupplierdepotOptions().then(function (res) {
            var data = Array.isArray(res.data.data) ? res.data.data : [];
            _this.depotList = data;
        });
    };
    __decorate([
        Prop({
            required: true,
            type: Number,
        })
    ], default_1.prototype, "handleStatus", void 0);
    __decorate([
        Prop({
            required: true,
        })
    ], default_1.prototype, "formData", void 0);
    default_1 = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                openedCodeData: 'openedCodeData',
            })),
            components: {
                HeaderItem: HeaderItem,
            },
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
